var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6955 3.01093C28.2292 1.92969 29.771 1.92969 30.3046 3.01093L37.2124 17.0078C37.4244 17.4371 37.834 17.7347 38.3078 17.8036L53.7542 20.0481C54.9474 20.2214 55.4239 21.6878 54.5604 22.5294L43.3833 33.4244C43.0405 33.7586 42.884 34.2402 42.9649 34.7121L45.6035 50.0961C45.8073 51.2845 44.56 52.1907 43.4927 51.6297L29.677 44.3663C29.2532 44.1435 28.7469 44.1435 28.3231 44.3663L14.5074 51.6297C13.4402 52.1907 12.1928 51.2845 12.3966 50.0961L15.0352 34.7121C15.1161 34.2402 14.9597 33.7586 14.6168 33.4244L3.43969 22.5294C2.57626 21.6878 3.05271 20.2214 4.24594 20.0481L19.6923 17.8036C20.1662 17.7347 20.5758 17.4371 20.7877 17.0078L27.6955 3.01093Z",
    stroke: "#00A1E4",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f5059b7b9d3ab24d49899492ef1cc9d9.svg";
export { ForwardRef as ReactComponent };